import { render, staticRenderFns } from "./MapaEducacaoEmpreendedora.vue?vue&type=template&id=12effc38&"
import script from "./MapaEducacaoEmpreendedora.vue?vue&type=script&lang=js&"
export * from "./MapaEducacaoEmpreendedora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports